import { createAction, props } from '@ngrx/store';
import { MultiContractData } from '@app/services/signal-r/model/multicontract-data';

const prefix = '[FAXE-MULTI-CONTRACT';


export const addMultiContractData = createAction(
  `${prefix} - add`,
  props<{ multiContractData: MultiContractData, issuerStack: string[]  }>()
);

export const addMultiContractDataBatch = createAction(
  `${prefix} - add batch`,
  props<{ multiContractDataBatch: MultiContractData[], issuerStack: string[]  }>()
);

export const purgeMultiContractDataByIds = createAction(
  `${prefix} - Purge By Ids'`,
  props<{ ids: string[] }>()
);
